/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { type FC } from 'react';

import { I18n } from '@coze-arch/i18n';
import { Button } from '@coze-arch/coze-design';

export interface PublishModalFooterProps {
  cancelText?: string;
  okText?: string;
  okLoading?: boolean;
  okDisabled?: boolean;
  onCancel: () => void;
  onOk: () => void;
}

/** ABR 标准弹窗底栏：取消 + 确认，右对齐、内容宽度（非铺满）。 */
export const PublishModalFooter: FC<PublishModalFooterProps> = ({
  cancelText = I18n.t('Cancel'),
  okText = I18n.t('Confirm'),
  okLoading,
  okDisabled,
  onCancel,
  onOk,
}) => (
  <div className="coz-modal-footer flex gap-2 justify-end">
    <Button className="!ml-0" color="primary" onClick={onCancel}>
      {cancelText}
    </Button>
    <Button
      className="!ml-0"
      color="brand"
      loading={okLoading}
      disabled={okDisabled}
      onClick={onOk}
    >
      {okText}
    </Button>
  </div>
);
